import { render, staticRenderFns } from "./StudentActivityTableFilesCell.vue?vue&type=template&id=f431d648&scoped=true&"
import script from "./StudentActivityTableFilesCell.vue?vue&type=script&lang=ts&"
export * from "./StudentActivityTableFilesCell.vue?vue&type=script&lang=ts&"
import style0 from "./StudentActivityTableFilesCell.vue?vue&type=style&index=0&id=f431d648&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f431d648",
  null
  
)

export default component.exports